import { GameObjects } from "phaser";

export default class CupFiller {
    constructor(scene, x, y, object) {

        this.bar = new GameObjects.Graphics(scene);
        this.x = x;
        this.y = y;
        this.value = 0;
        this.p = 100 / 100;

        this.draw();

        this.image = scene.add.image(x, y, object, 0).setScale(2).setOrigin(1, 0).setScrollFactor(0);
        scene.add.existing(this.bar);
            
    }

    setVisible(visible) {
        this.image.setVisible(visible);
        this.bar.setVisible(visible);
    }

    restartBar() {
        this.value = 0;
        this.draw();
    }

    increase (amount)
    {
        this.value += amount;

        if (this.value > 100)
        {
            this.value = 100;
        }

        this.draw();

        return (this.value === 100);
    }

    draw ()
    {
        this.bar.clear();

        //  BG
        this.bar.fillStyle(0x000000);
        this.bar.fillRect((this.x+5), (this.y + 5), 100, 16);

        //  Health

        this.bar.fillStyle(0xffffff);
        this.bar.fillRect((this.x +5)+ 2, (this.y + 5)+ 2, 96, 12);

        if (this.value < 30)
        {
            this.bar.fillStyle(0xff0000);
        }
        else
        {
            this.bar.fillStyle(0x00ff00);
        }

        var d = Math.floor(this.p * this.value);

        this.bar.fillRect((this.x +5)+ 2, (this.y+5) + 2, d, 12);

    }

    // updatePosition(x, y) {
    //     this.bar.setPosition(x, y);
    // }
    
    // setScale(scale) {
    //     this.bar.setScale(scale);
    // }

    setScrollFactor(scroll) {
        this.bar.setScrollFactor(scroll);
    }

    setOrigin(x , y) {
        this.bar.setOrigin(x, y);
    }

}